module.exports = __webpack_public_path__ + "static/media/tetris.4ae866dc.mp3";